import React, { Component } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { connect } from 'dva';
import { Form, Input, Select, Spin, Row, Col, Card } from 'antd';
import ButtonBar from '../../ButtonBar/ButtonBar';
import {
  ACTION_APP_GO_TO_ROUTE,
  ACTION_APP_ADD_NOTIFICATION,
} from '../../../models/app';

import {
  ACTION_COUNTRY_REGIONS_CREATE,
  ACTION_COUNTRY_REGIONS_LOAD_ITEM,
  ACTION_COUNTRY_REGIONS_UPDATE,
} from '../../../models/countryRegions';
import { ACTION_COUNTRIES_LOAD_LIST } from '../../../models/countries';
import { ACTION_HEADER_UPDATE } from '../../../models/header';
import { ROUTE_COUNTRY_REGIONS } from '../../../routes';
import helpers from '../../../utils/helpers';
import styles from './../styles.less';

const { Item } = Form;
const { Option } = Select;

class CountryRegionsItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      countryRegion: {
        id: this.props.match.params.countryRegionId
          ? this.props.match.params.countryRegionId
          : null,
        name: '',
        countries: [],
      },
    };
  }

  componentDidMount() {
    const {
      countryRegion: { id },
    } = this.state;

    this.props.dispatch({ type: ACTION_COUNTRIES_LOAD_LIST });

    if (id) {
      const payload = {
        id,
      };
      this.props
        .dispatch({ type: ACTION_COUNTRY_REGIONS_LOAD_ITEM, payload })
        .then((response) => {
          this.setForm(response);
        });
    }

    this.props.dispatch({
      type: ACTION_HEADER_UPDATE,
      payload: {
        title: id
          ? 'Component.CountryRegions.Form.Title.Edit'
          : 'Component.CountryRegions.Form.Title.New',
      },
    });
  }

  setForm(response) {
    const countries = response.countries.map(c => c.id);
    const newState = {
      countryRegion: {
        ...response,
        countries,
      },
    };
    this.setState(newState);
  }

  handleSubmit = (e) => {
    e.preventDefault();
    const { getFieldValue, validateFields } = this.props.form;
    validateFields((err) => {
      if (!err) {
        const name = getFieldValue('name');
        const countries = getFieldValue('countries');
        const data = { name, countries };
        this.saveCountryRegion(data);
      }
    });
  };

  saveCountryRegion(data) {
    const {
      countryRegion: { id },
    } = this.state;

    this.props
      .dispatch({
        type: id
          ? ACTION_COUNTRY_REGIONS_UPDATE
          : ACTION_COUNTRY_REGIONS_CREATE,
        payload: {
          id,
          data,
        },
      })
      .then(() => {
        this.goToCountryRegions();
        this.addNotification(id);
      });
  }

  addNotification(id) {
    this.props.dispatch({
      type: ACTION_APP_ADD_NOTIFICATION,
      payload: {
        type: 'success',
        message: 'Common.Success',
        description: id
          ? 'Component.CountryRegions.Edit.Success.Text'
          : 'Component.CountryRegions.New.Success.Text',
      },
    });
  }

  goToCountryRegions = () => {
    this.props.dispatch({
      type: ACTION_APP_GO_TO_ROUTE,
      payload: { routeName: ROUTE_COUNTRY_REGIONS },
    });
  };

  render() {
    const { countryRegion } = this.state;
    const { loading, form, intl, countries } = this.props;
    const { getFieldDecorator } = form;
    return (
      <Spin
        spinning={
          !!loading.effects[ACTION_COUNTRY_REGIONS_CREATE] ||
          !!loading.effects[ACTION_COUNTRY_REGIONS_UPDATE] ||
          !!loading.effects[ACTION_COUNTRY_REGIONS_LOAD_ITEM]
        }
      >
        <div className={styles.containerLarge}>
          <Form onSubmit={this.handleSubmit}>
            <Card>
              <Row>
                <Col>
                  <Item
                    label={
                      <FormattedMessage id="Component.CountryRegions.Form.Name" />
                    }
                  >
                    {getFieldDecorator('name', {
                      initialValue: countryRegion.name,
                      rules: [
                        {
                          required: true,
                          min: 3,
                          max: 255,
                          message: intl.formatMessage({
                            id: 'Component.CountryRegions.Validation.Name',
                          }),
                        },
                      ],
                    })(<Input maxLength={255} type="text" />)}
                  </Item>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Item
                    label={
                      <FormattedMessage id="Component.CountryRegions.Form.Countries" />
                    }
                  >
                    {getFieldDecorator('countries', {
                      initialValue: countryRegion.countries,
                      rules: [
                        {
                          required: true,
                          message: intl.formatMessage({
                            id: 'Component.CountryRegions.Validation.Countries',
                          }),
                        },
                      ],
                    })(
                      <Select
                        mode="multiple"
                        showArrow
                        filterOption={helpers.multipleSelectFilter}
                      >
                        {countries.countriesList.map(item => (
                          <Option key={item.id} value={item.id}>
                            {item.name}
                          </Option>
                        ))}
                      </Select>,
                    )}
                  </Item>
                </Col>
              </Row>
            </Card>
            <ButtonBar cancelAction={this.goToCountryRegions} />
          </Form>
        </div>
      </Spin>
    );
  }
}

export default connect(({ countries, loading }) => ({
  countries,
  loading,
}))(Form.create()(injectIntl(CountryRegionsItem)));



// WEBPACK FOOTER //
// ./src/components/CountryRegions/CountryRegionsItem/CountryRegionsItem.js